// @flow
import {connect} from 'react-redux';
import type {State as ReduxState} from '../../reducers/index';
import type {SearchQueryResults} from '../../queries/searchQuery';
import type {ListingShape} from '../Hit/Hit';
import type {Element as ReactElement} from 'react';

type StateProps = {
    openExpandedGroupIndexes: number[]
};

type Props = StateProps & {
    render: (any) => ReactElement<*>,
    results: ?SearchQueryResults
};

/**
 *
 * augments listings data with any
 * possibly open expanded groups listings data
 */
// TODO: change this to not use a render prop. It should just be a MapContainer to do this
// Code is tightly coupled and flow types not easy to set using current pattern
// https://jira.homeawaycorp.com/browse/SERP-2858
export function MapHitsDataProvider({
    openExpandedGroupIndexes,
    results,
    render,
    ...rest
}: Props) {
    const {expandedGroups} = results || {};

    const openExpandedGroupsData: {
        listings: ListingShape[]
    } = (expandedGroups &&
        expandedGroups.reduce(
            (previousValue, expandedGroup, currentIndex) => {
                if (
                    openExpandedGroupIndexes.includes(currentIndex) &&
                    expandedGroup.listings
                ) {
                    return {
                        listings: [
                            ...previousValue.listings,
                            ...expandedGroup.listings
                        ]
                    };
                }
                return previousValue;
            },
            {listings: []}
        )) || {listings: []};

    const listings = [
        ...((results && results.listings) || []),
        ...openExpandedGroupsData.listings
    ];

    const pageSize = results && results.pageSize;
    const page = results && results.page;

    return render({listings, pageSize, page, ...rest});
}

const mapStateToProps = ({
    expandedGroups: {openGroupIndexes: openExpandedGroupIndexes}
}: ReduxState): StateProps => ({
    openExpandedGroupIndexes
});

export default connect(mapStateToProps)(MapHitsDataProvider);
